module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeAbsenceReason) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.change_start_and_end_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body d-modal__body--edit-absence"
  }, [_c('div', {
    staticClass: "d-modal__body--edit-absence__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.showUser.default_thumb_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absent-user__name"
  }, [_c('h3', [_vm._v(_vm._s(_vm.showUser.name))]), _vm._v(" "), _c('div', {
    staticClass: "reason"
  }, [_c('p', [_vm._v(_vm._s(_vm.getReasonTitle(_vm.activeAbsenceReason)) + "\n            ")]), _c('p', [(_vm.isOngoing && _vm.isAbsenceOngoing) ? _c('span', {
    staticClass: "badge badge--orange badge--small"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))]) : _vm._e(), _vm._v(" "), (!_vm.isOngoing && _vm.getIsAbsenceMultipleDays) ? _c('span', {
    staticClass: "badge badge--small"
  }, [_vm._v(" " + _vm._s(_vm.$t('vue2.substitution_user.multiple_days')))]) : _vm._e()])]), _vm._v(" "), _c('p', [(_vm.getSerialListItem) ? _c('span', [_vm._v("\n            " + _vm._s(_vm._f("date")(_vm.getSerialListItem.from_date)) + "\n            - " + _vm._s(_vm._f("date")(_vm.getSerialListItem.to_date)) + ", " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.from_time)) + " - " + _vm._s(_vm._f("showTime")(_vm.getSerialListItem.to_time)) + "\n          ")]) : _c('span', [_vm._v("\n            " + _vm._s(_vm._f("showDate")(_vm.activeAbsenceReason.start)) + " -\n            "), _c('span', [_vm._v(_vm._s(_vm._f("showTime")(_vm.activeAbsenceReason.end)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__body"
  }, [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('div', {
    staticClass: "d-modal__page-1"
  }, [(_vm.reason) ? _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason')))]), _vm._v(" "), _c('div', {
    staticClass: "absence-reason"
  }, [_c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.subsAbsenceReasonsSorted,
      "multiple": false,
      "items-selected": _vm.reason,
      "placeholder": _vm.$t('vue2.substitution.choose_absence_reason')
    },
    on: {
      "update": _vm.setReason
    }
  }, [_c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_c('h4', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.dselect.no_matching_results')) + "\n                    ")])])])], 1)]), _vm._v(" "), (_vm.showErrors) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.reason_must_be_filled')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.date_label')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.originalStart,
      "enddate": _vm.originalEnd
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absence-no-end-date",
    class: [{
      'absence-no-end-date--active': _vm.isAbsenceOngoing
    }, {
      'absence-no-end-date--disabled': !_vm.isOngoingAbsenceAllowed
    }]
  }, [(!_vm.isOngoingAbsenceAllowed) ? _c('div', {
    staticClass: "absence-no-end-date--not-allowed"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "absence-no-end-date__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isAbsenceOngoing = !_vm.isAbsenceOngoing
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isAbsenceOngoing
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')))])], 1), _vm._v(" "), _c('DQuestionMark', [_c('p', {
    attrs: {
      "slot": "answer"
    },
    slot: "answer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence_explained')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__body__input-group"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.time')))]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.deleteAbsenceFollowingDates.length > 0) ? _c('p', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.absence_will_be_deleted')))]), _vm._v(" "), _vm._l((_vm.deleteAbsenceFollowingDates), function(date, idx) {
    return _c('span', [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("date")(date)))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length > 0) ? _c('div', {
    staticClass: "d-modal__page-2"
  }, [_c('SubsDeleteAbsence', {
    attrs: {
      "calendarId": this.activeAbsenceReason.calendar_id,
      "firstRange": _vm.originalDatesNotInNewRangeMinimum,
      "lastRange": _vm.originalDatesNotInNewRangeMaximum,
      "dates": _vm.originalDatesNotInNewRange,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime
    },
    on: {
      "lessonsWithSubs": _vm.setLessonsWithSubs,
      "gotLessons": function($event) {
        _vm.isLessonsLoaded = true
      },
      "changed": _vm.setDeleteSubs
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__body--edit-absence__actions"
  }, [_c('div', [(!_vm.isActiveAbsenceReasonIsReadyToDelete) ? _c('button', {
    staticClass: "bttn bttn-danger marg-5-right",
    on: {
      "click": function($event) {
        return _vm.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body--edit-absence__actions__right"
  }, [_c('button', {
    staticClass: "marg-5-right",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (_vm.isActiveAbsenceReasonIsReadyToDelete) ? [_c('button', {
    staticClass: "submit-button submit-button--danger",
    on: {
      "click": _vm.removeSubsAndDeleteAbsence
    }
  }, [(_vm.eventsToRemovedSubs.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.remove_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length > 0 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.keep_subs_and_delete_absence')))]) : _vm._e(), _vm._v(" "), (_vm.lessonsWithSubs.length < 1 && _vm.eventsToRemovedSubs.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.delete_absence')))]) : _vm._e()])] : [(_vm.originalDatesNotInNewRange.length > 0) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.removeSubsAndUpdateAbsence
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.originalDatesNotInNewRange.length < 1 && this.eventsToRemovedSubs.length < 1) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.updateDates
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.common.update')) + "\n            ")]) : _vm._e()]], 2)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f3c020a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsEditAbsence.vue
// module id = 1606
// module chunks = 1